import React from "react";

interface HierarchyPathSegment {
  label: string;
  active?: boolean;
}

interface HierarchyPathProps {
  segments: HierarchyPathSegment[];
}

const HierarchyPath: React.FC<HierarchyPathProps> = ({ segments }) => {
  return (
    <nav aria-label="Context path" className="flex items-center gap-2">
      {segments.map((segment, index) => (
        <React.Fragment key={segment.label}>
          {index > 0 && <span className="text-gray-400">›</span>}
          <span
            className={
              segment.active
                ? "font-medium text-gray-900"
                : "font-medium text-gray-500"
            }
          >
            {segment.label}
          </span>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default HierarchyPath;